/* eslint-disable react/prop-types */
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default function Addandeditform({ visible, setVisible, formdata, handlechange, handlesave, handleupdate, }) {
  const [editorContent, setEditorContent] = useState(formdata.Content || "");

  useEffect(() => {
    setEditorContent(formdata.Content || "");
  }, [formdata.Content]);

  const handleEditorChange = (content) => {
    setEditorContent(content);
    handlechange({ target: { name: "Content", value: content } });
  };

  return (
    <Dialog header="Current Affairs Form" visible={visible} onHide={() => { if (!visible) return; setVisible(false);}} style={{ width: "50vw" }} breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      maximizable >
      <form onSubmit={!formdata._id ? handlesave : handleupdate}>
        <div className="grid grid-cols-1 gap-y-2">
        <div>
            <div>
              <label>Content</label>
            </div>
            <SunEditor
              setContents={editorContent}
              onChange={handleEditorChange}
              setOptions={{
                defaultStyle: "font-family: Arial, sans-serif;",
                font: ["Arial"],
                buttonList: [
                  ["undo", "redo", "fontSize", "formatBlock"],
                  [
                    "bold",
                    "underline",
                    "italic",
                    "strike",
                    "subscript",
                    "superscript",
                    "removeFormat",
                  ],
                  ["fontColor", "hiliteColor", "textStyle"],
                  ["align", "list", "lineHeight"],
                  ["outdent", "indent"],
                  ["table", "link", "image", "video"],
                  ["fullScreen", "showBlocks", "codeView"],
                  ["preview", "print"],
                ],
              }}
              height="350px"
            />
          </div>
          <div>
            <div>
              <label>Current Affair Type</label>
            </div>
            <input type="text" name="Current_Affair_Type" value={formdata["Current_Affair_Type"] || ""} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} required/>
          </div>
          <div>
            <div>
              <label>Category</label>
            </div>
            <input type="text" name="Category" value={formdata["Category"] || ""} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} required />
          </div>
          <div>
            <div>
              <label>Title</label>
            </div>
            <input type="text" name="Title" value={formdata["Title"] || ""} className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} required/>
          </div>
         
          <div>
            <div>
              <label>Status</label>
            </div>
            <select name="Status" className="w-full px-4 py-2 mt-1 border outline-none rounded-xl" onChange={handlechange} value={formdata.Status || ""} required>
              <option value="">---Select a Status---</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div className="flex justify-end gap-5 mt-5">
          <button type="button" onClick={() => setVisible(false)}>Cancel</button>
          <button type="submit" className="px-4 py-2 text-white bg-secondary rounded-xl">
            <i className="fi fi-br-check"></i>{" "}
            {!formdata._id ? "Save" : "Update"}
          </button>
        </div>
      </form>
    </Dialog>
  );
}